var render = function () {
  var _vm$collection$name;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CollectionList",
      "extra-items": [(_vm$collection$name = _vm.collection.name) !== null && _vm$collection$name !== void 0 ? _vm$collection$name : '']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.collection.name))])]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-tabs', {
    on: {
      "input": _vm.handleUserChangesTab
    },
    model: {
      value: _vm.activeTabIndex,
      callback: function callback($$v) {
        _vm.activeTabIndex = $$v;
      },
      expression: "activeTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "基本設定"
    }
  }, [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-end"
  }, [_c('div', {
    class: ['col-12', _vm.query.branch_id === 'null' ? 'col-xl-8' : 'col-xl-6', 'd-flex', 'flex-column', 'flex-xl-row', 'align-items-center', 'justify-content-xl-end']
  }, [_vm.checkPermission([_vm.consts.COLLECTION_ITEM_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CollectionItemCreate',
        query: {
          branch_id: _vm.query.branch_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增項目")]) : _vm._e(), _vm.query.branch_id === 'null' && _vm.showBranchSelect && _vm.checkPermission([_vm.consts.COLLECTION_ITEM_SYNC_BRANCH]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSyncCollectionToBranch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-sync",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("同步至所有分店 ")]) : _vm._e(), _vm.showBranchSelect && _vm.activeTabIndex == 0 ? _c('AppSingleSelect', {
    ref: "items",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": !this.checkPermission([_vm.consts.COLLECTION_ITEM_LIST_BRANCH])
    },
    on: {
      "input": _vm.formatAndFetch
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  }) : _vm._e(), _c('b-input-group', {
    staticClass: "col-12 col-xl-4 mb-2"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.COLLECTION_ITEM_EDIT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'CollectionItemEdit',
              params: {
                id: _vm.collection.id,
                item_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.COLLECTION_ITEM_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteItem(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }, {
      key: "cell()",
      fn: function fn(data) {
        return [data.field.type === 'uploader' ? [data.value ? _c('a', {
          attrs: {
            "href": data.value,
            "target": "_blank"
          }
        }, [_vm._v("（查看檔案）")]) : [_vm._v("（無檔案）")]] : data.field.is_dynamic_generated ? [data.value !== undefined ? _c('TableCell', {
          attrs: {
            "content": data.value,
            "title": _vm.fields.find(function (f) {
              return f.key === data.field.key;
            }).label
          }
        }) : _vm._e()] : [_vm._v(_vm._s(data.value))]];
      }
    }])
  })], 1), _c('b-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isRelatedBranch,
      expression: "isRelatedBranch"
    }],
    attrs: {
      "title": "啟用管理"
    }
  }, [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-end"
  }, [_c('div', {
    staticClass: "\n                      col-12 col-xl-6\n                      d-flex\n                      flex-column flex-xl-row\n                      align-items-center justify-content-xl-end\n                    "
  }, [_vm.checkPermission([_vm.consts.COLLECTION_ITEM_CREATE]) && _vm.selectedItems.length > 0 ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.changeRelationIsEnabled
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("更新狀態")]) : _vm._e(), _vm.checkPermission([_vm.consts.COLLECTION_ITEM_SYNC_SINGLE_BRANCH]) && this.query.branch_id && this.query.branch_id !== 'null' ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSyncCollectionToSingleBranch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-sync",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("立即同步至此分店 ")]) : _vm._e(), _vm.showBranchSelect && _vm.activeTabIndex == 1 ? _c('AppSingleSelect', {
    ref: "items",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": !this.checkPermission([_vm.consts.COLLECTION_ITEM_LIST_BRANCH])
    },
    on: {
      "input": _vm.formatAndFetch
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  }) : _vm._e()], 1)]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell()",
      fn: function fn(data) {
        return [data.field.type === 'uploader' ? [data.value ? _c('a', {
          attrs: {
            "href": data.value,
            "target": "_blank"
          }
        }, [_vm._v("（查看檔案）")]) : [_vm._v("（無檔案）")]] : data.field.is_dynamic_generated ? [data.value !== undefined ? _c('TableCell', {
          attrs: {
            "content": data.value,
            "title": _vm.fields.find(function (f) {
              return f.key === data.field.key;
            }).label
          }
        }) : _vm._e()] : [_vm._v(_vm._s(data.value))]];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.COLLECTION_ITEM_EDIT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'CollectionItemStaffList',
              params: {
                id: _vm.collection.id,
                item_id: data.item.item_id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 員工列表 ")]) : _vm._e()];
      }
    }, {
      key: "head(checkbox)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.toggleSelectAll
          },
          model: {
            value: _vm.selectAll,
            callback: function callback($$v) {
              _vm.selectAll = $$v;
            },
            expression: "selectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(checkbox)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          model: {
            value: data.item.selected,
            callback: function callback($$v) {
              _vm.$set(data.item, "selected", $$v);
            },
            expression: "data.item.selected"
          }
        })];
      }
    }])
  })], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }